import { Button, Grid, Box, IconButton, Stack, Typography, TextField as MuiTextField, Checkbox } from '@mui/material';
import { useForm } from 'react-hook-form';
import CloseIcon from '@mui/icons-material/Close';
import { FormProvider, SelectTag, Table, TextField } from '../../../../../components';
import { useCallback, useEffect, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { dropdownFetch } from '../../../../../utils';
import { dateFormatter } from '../../../../../utils';

const TABLE_HEADER = [
  {
    header: 'Product Name',
    accessor: (row) => row?.name
  }
];

const STOCK_STATUS_HEADER = [
  {
    header: 'Batch No.',
    accessor: ''
  },
  {
    header: 'Exp Date',
    accessor: ''
  },
  {
    header: 'Stock',
    accessor: ''
  }
];

const PURCHASE_HISTORY_HEADER = [
  {
    header: 'Dated',
    accessor: (row) => dateFormatter(row?.createdAt)
  },
  {
    header: 'Supplier',
    accessor: 'supplier'
  },
  {
    header: 'Rate',
    accessor: 'rate'
  },
  {
    header: 'MRP',
    accessor: 'mrp'
  },
  {
    header: 'Sales Price',
    accessor: 'sal_rate'
  }
];

export const ConsignmentReceiptAddDetailsForm = ({
  onClose,
  chargeType = 'opd_charges',
  doctorID,
  onAdd,
  productDropdown,
  setFilteredServiceList,
  filteredServiceList
}) => {
  const [input, setInput] = useState('');
  const [activeTab, setActiveTab] = useState(0);
  const [consignment, setConsignment] = useState([]);

  // Function to merge serviceDropdown and testDropdown data
  const mergeDropdowns = useCallback(() => {
    // Comment: Merging serviceDropdown and testDropdown data into one array
    const mergedData = [
      ...productDropdown.map((item) => ({
        ...item,
        type: item.type || 'service',
        name: item.name
      }))
    ];
    return mergedData;
  }, [productDropdown]);

  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
        product: Yup.string().required('Please Enter Product'),
        bill_qty: Yup.string().required('Please Enter Product'),
        rate: Yup.string().required('Please Enter Product'),
        batch_no: Yup.string().required('Please Enter Batch No'),
        exp_date: Yup.string().required('Please Enter Exp Date'),
        mrp: Yup.string().required('Please Enter Product'),
        sal_rate: Yup.string().required('Please Enter Sale Date')
      })
    ),
    defaultValues: {
      po_qty: 0,

      free_qty: 0,
      loose_qty: 0,
      rec_qty: 0,
      quantity: 1,
      amount: 0,
      net_amt: 0,
      gst_amt: 0,
      disc_amt: 0,
      disc_per: 0,
      gst_per: 0,
      sgst: 0,
      cgst: 0
    },
    mode: 'all'
  });
  const { reset } = methods;

  const { handleSubmit, setValue, watch } = methods;

  const formSubmitHandler = (formValues) => {
    formValues.gst_per = +formValues.gst_per;
    formValues.disc_per = +formValues.disc_per;
    formValues.quantity = +formValues.quantity;
    const productId = productDropdown.find(({ name }) => name === formValues.product)?._id || '';
    const transformedValues = {
      ...formValues,
      product: productId
    };
    console.log('HELLLO TRANSFORMED VALUES', transformedValues);
    onAdd(transformedValues);
    reset();
  };

  const handleServiceSelection = (row) => {
    console.log('HELLLO SERVICE SELECTION', row);
    const isProduct = productDropdown.some((product) => product._id === row._id);
    if (isProduct) {
      setValue('rate', row[chargeType] || 0);
    }
    methods.resetField('product');
    setValue('product', row?.name);
    setValue('unit', row?.purchasing_unit?.unit_name);
    setValue('hsn_code', row?.hsn_code);
    setValue('gst', row?.tax_percentage);
    setValue('packing', row?.packing);
    setValue('conversion', row?.conversion);
  };

  const billQty = watch('bill_qty');
  const rate = watch('rate');
  const freeQty = watch('free_qty');
  const discPerWatch = watch('dis_percent');
  const discAmtWatch = watch('dis_amt');
  const gstPerWatch = watch('gst');
  const mrp = watch('mrp');

  useEffect(() => {
    const amount = billQty * rate;
    const RecQty = Number(freeQty) + Number(billQty);
    const discAmt = parseFloat(((amount * discPerWatch) / 100).toFixed(2));
    const taxable = parseFloat((amount - discAmt).toFixed(2));
    const gstAmt = parseFloat((((amount - discAmt) * gstPerWatch) / 100).toFixed(2));
    const netAmt = parseFloat((Number(taxable) + Number(gstAmt)).toFixed(2));
    const sgst = gstAmt / 2;
    setValue('amount', parseFloat(amount.toFixed(2)));
    setValue('dis_amt', discAmt || 0);
    setValue('gst_amt', gstAmt || 0);
    setValue('taxable', taxable || 0);
    setValue('rec_qty', RecQty || 0);
    setValue('sal_rate', mrp || 0);
    setValue('net_amt', netAmt || 0);
    setValue('sgst', sgst || 0);
    setValue('cgst', sgst || 0);
  }, [billQty, rate, discPerWatch, gstPerWatch, freeQty, setValue]);

  useEffect(() => {
    if (billQty && rate && discAmtWatch !== undefined) {
      const amount = billQty * rate;
      const newDiscPer = parseFloat(((discAmtWatch / amount) * 100).toFixed(2));
      setValue('dis_percent', newDiscPer);
    }
  }, [billQty, rate, discAmtWatch, setValue]);

  useEffect(() => {
    if (mrp !== undefined) {
      setValue('sal_rate', mrp);
    }
  }, [mrp, setValue]);

  useEffect(() => {
    const filtered = mergeDropdowns().filter(
      (item) => item?.name?.toLowerCase().includes(input.toLowerCase()) // using includes instead of strict equality
    );
    setFilteredServiceList(filtered);
  }, [input, mergeDropdowns]);

  const handleInputChange = (e) => {
    setInput(e.target.value);
  };

  const handleActiveTab = (newTabIndex) => {
    setActiveTab(newTabIndex);
  };
  const product = watch('product');

  const getConsignmentDropdown = useCallback(async () => {
    const data = await dropdownFetch('consignment-receipt-add-details');
    setConsignment(data);
  }, []);

  useEffect(() => {
    getConsignmentDropdown();
  }, [getConsignmentDropdown]);

  return (
    <Stack spacing={1}>
      <Stack
        direction="row"
        spacing={2}
        alignItems="center"
        justifyContent="space-between"
        borderBottom="0px solid"
        borderColor="grey.300"
      >
        <Typography variant="h4" fontWeight="bold">
          Add Details
        </Typography>
        <IconButton onClick={onClose}>
          <CloseIcon color="error" fontSize="large" />
        </IconButton>
      </Stack>

      <FormProvider
        sx={{ height: '100%', overflow: 'auto' }}
        methods={methods}
        onSubmit={handleSubmit(formSubmitHandler)}
      >
        <Grid container spacing={1} sx={{ flex: 1, height: '100%', overflow: 'auto' }}>
          <Grid
            item
            xs={4}
            sx={{
              height: '100%',
              overflow: 'auto',
              display: 'flex',
              flexDirection: 'column',
              gap: 1
            }}
          >
            <Typography variant="h6">No. Of Product :- {productDropdown.length}</Typography>
            <Stack direction="row" spacing={2} alignItems="center" justifyContent="center" sx={{ mt: 2 }}>
              <MuiTextField
                sx={{
                  width: '100%',
                  '& .MuiOutlinedInput-root': {
                    padding: '0'
                  },
                  '& .MuiOutlinedInput-input': {
                    padding: '8px 14px'
                  }
                }}
                label="Search Product"
                variant="outlined"
                value={input}
                onChange={handleInputChange}
                InputProps={{
                  style: {
                    fontSize: '12px',
                    fontWeight: 600
                  }
                }}
              />
            </Stack>
            <Table
              containerSX={{ flex: 1, height: '100%', overflow: 'auto' }}
              size="small"
              sx={{ fontSize: '32px' }}
              data={filteredServiceList.length > 0 ? filteredServiceList : mergeDropdowns()}
              columns={TABLE_HEADER}
              onRowClick={handleServiceSelection}
            />
          </Grid>
          <Grid item xs={8}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.3, px: 2 }}>
              <Stack spacing={1} direction="row" alignItems="center">
                <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>Product</Typography>
                <TextField sx={{ flex: 1 }} name="product" placeholder="Select Product" disabled />
              </Stack>
              <Stack spacing={1} direction="row" alignItems="center">
                <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Unit</Typography>
                <TextField sx={{ flex: 0.4 }} disabled name="unit" />
                <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Po Qty</Typography>
                <TextField sx={{ flex: 0.38 }} disabled name="po_qty" />
                <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Pen. Qty</Typography>
                <TextField sx={{ flex: 0.4 }} disabled name="pedning_qty" />
              </Stack>
              <Stack spacing={1} direction="row" alignItems="center">
                <Typography sx={{ flex: 0.39, fontWeight: 700, fontSize: '1.4rem' }}>Free Qty</Typography>
                <TextField sx={{ flex: 0.38 }} name="free_qty" />
                <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Loose Qty</Typography>
                <TextField sx={{ flex: 0.38 }} name="loose_qty" />
                <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Rec. Qty</Typography>
                <TextField sx={{ flex: 0.4 }} disabled name="rec_qty" />
              </Stack>
              <Stack spacing={1} direction="row" alignItems="center">
                <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Bill Qty</Typography>
                <TextField sx={{ flex: 0.4, border: '0.5px solid red' }} name="bill_qty" />
                <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Rate</Typography>
                <TextField sx={{ flex: 0.4, border: '0.5px solid red' }} name="rate" />
                <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>MRP</Typography>
                <TextField sx={{ flex: 0.4, border: '0.5px solid red' }} name="mrp" />
              </Stack>

              <Stack spacing={1} direction="row" alignItems="center">
                <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Batch No</Typography>
                <TextField sx={{ flex: 0.4, border: '0.5px solid red' }} name="batch_no" />
                <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Exp. Date</Typography>
                <TextField sx={{ flex: 0.4, border: '0.5px solid red' }} name="exp_date" type="month" />
                <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Dis%</Typography>
                <TextField sx={{ flex: 0.4 }} name="dis_percent" />
              </Stack>

              <Stack spacing={1} direction="row" alignItems="center">
                <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Sal. Rate</Typography>
                <TextField sx={{ flex: 0.4 }} name="sal_rate" />
                <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Packing</Typography>
                <TextField sx={{ flex: 0.4 }} disabled name="packing" />
                <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Conversion</Typography>
                <TextField sx={{ flex: 0.4 }} name="conversion" />
              </Stack>

              <Stack spacing={1} direction="row" alignItems="center">
                <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Mfg. Date</Typography>
                <TextField sx={{ flex: 0.4 }} name="mfg_date" type="month" />
                <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Dis Amt.</Typography>
                <TextField sx={{ flex: 0.4 }} name="dis_amt" />
                <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Amount</Typography>
                <TextField sx={{ flex: 0.4 }} disabled name="amount" />
              </Stack>

              <Stack spacing={1} direction="row" alignItems="center">
                <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Sal. Dis.</Typography>
                <TextField sx={{ flex: 0.4 }} name="sal_dis" />
                <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>HSN Code</Typography>
                <TextField sx={{ flex: 0.4 }} name="hsn_code" disabled />
                <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Taxable</Typography>
                <TextField sx={{ flex: 0.4 }} disabled name="taxable" />
              </Stack>
              <Stack spacing={1} direction="row" alignItems="center">
                <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>GST%</Typography>
                <TextField sx={{ flex: 0.4 }} disabled name="gst" />
                <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>SGST</Typography>
                <TextField sx={{ flex: 0.4 }} disabled name="sgst" />
                <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>CGST</Typography>
                <TextField sx={{ flex: 0.4 }} disabled name="cgst" />
              </Stack>

              <Stack spacing={1} direction="row" alignItems="center">
                <Typography sx={{ flex: 0.17, fontWeight: 700, fontSize: '1.4rem' }}>IGST</Typography>
                <TextField sx={{ flex: 0.18 }} disabled name="igst" />
                <Typography sx={{ flex: 0.19, fontWeight: 700, fontSize: '1.4rem' }}>Net Amt</Typography>
                <TextField sx={{ flex: 0.55 }} disabled name="net_amt" />
              </Stack>
              <Stack spacing={1} direction="row" alignItems="center" justifyContent="flex-end">
                <Button variant="contained" type="submit">
                  Add
                </Button>
                <Button variant="outlined" onClick={onClose} color="error">
                  Close
                </Button>
              </Stack>
            </Box>
            <Box sx={{ borderBottom: '1px solid', borderColor: 'divider' }}>
              <Button
                variant="contained"
                onClick={() => handleActiveTab(1)}
                sx={{
                  my: 0,
                  mx: 1,
                  borderRadius: '4px',
                  fontWeight: 700,
                  fontSize: '1rem',
                  backgroundColor: activeTab === 1 ? 'primary.main' : 'default',
                  color: activeTab === 1 ? 'white' : 'text.primary'
                }}
              >
                Stock Status
              </Button>
              <Button
                variant="contained"
                onClick={() => handleActiveTab(2)}
                sx={{
                  my: 0,
                  mx: 1,
                  borderRadius: '4px',
                  fontWeight: 700,
                  fontSize: '1rem',
                  backgroundColor: activeTab === 2 ? 'primary.main' : 'default',
                  color: activeTab === 2 ? 'white' : 'text.primary'
                }}
              >
                Purchase History
              </Button>
            </Box>
            {activeTab === 1 && (
              <Stack sx={{ mb: 0.3 }} direction="row" spacing={2} minHeight={'20rem'}>
                <Table
                  containerSX={{ flex: 1, border: '1px solid rgba(0,0,0,0.27)' }}
                  data={[]}
                  columns={STOCK_STATUS_HEADER}
                  size="small"
                />
              </Stack>
            )}
            {activeTab === 2 && (
              <Stack sx={{ mb: 0.3 }} direction="row" spacing={2} minHeight={'20rem'}>
                <Table
                  containerSX={{ flex: 1, border: '1px solid rgba(0,0,0,0.27)' }}
                  data={[]}
                  columns={PURCHASE_HISTORY_HEADER}
                  size="small"
                />
              </Stack>
            )}
          </Grid>
        </Grid>
      </FormProvider>
    </Stack>
  );
};
